import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export const findReplacePluginKey = new PluginKey('findReplaceDecorations');

export const FindReplaceExtension = Extension.create({
  name: 'findReplaceDecorations',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: findReplacePluginKey,
        state: {
          init() {
            return DecorationSet.empty;
          },
          apply(tr, oldSet) {
            const meta = tr.getMeta(findReplacePluginKey);
            if (meta !== undefined) {
              // meta is an array of Decoration objects, or empty array to clear
              if (meta.length === 0) return DecorationSet.empty;
              return DecorationSet.create(tr.doc, meta);
            }
            // Map existing decorations through document changes
            return oldSet.map(tr.mapping, tr.doc);
          },
        },
        props: {
          decorations(state) {
            return findReplacePluginKey.getState(state);
          },
        },
      }),
    ];
  },
});
